export const ANDROID_KEYBOARD_SLIDE_ANIMATION_DURATION = 500;
export { default as PostMessage } from "./PostMessage";
